var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 4h7a1 1 0 0 1 1 1v1H7V5a1 1 0 0 1 1-1M6 6V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v1h2.5a.5.5 0 0 1 0 1h-16a.5.5 0 0 1 0-1zm-.5 2a.5.5 0 0 1 .5.5v10A1.5 1.5 0 0 0 7.5 20h8a1.5 1.5 0 0 0 1.5-1.5v-10a.5.5 0 0 1 1 0v10a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 5 18.5v-10a.5.5 0 0 1 .5-.5m4.5.5a.5.5 0 0 0-1 0v9a.5.5 0 0 0 1 0zm3.5-.5a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-1 0v-9a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
});
const SvgDelete = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDelete);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDRIMTVDMTUuNTUyMyA0IDE2IDQuNDQ3NzIgMTYgNVY2SDdWNUM3IDQuNDQ3NzIgNy40NDc3MiA0IDggNFpNNiA2VjVDNiAzLjg5NTQzIDYuODk1NDMgMyA4IDNIMTVDMTYuMTA0NiAzIDE3IDMuODk1NDMgMTcgNVY2SDE5LjVDMTkuNzc2MSA2IDIwIDYuMjIzODYgMjAgNi41QzIwIDYuNzc2MTQgMTkuNzc2MSA3IDE5LjUgN0gxN0gxNkg3SDZIMy41QzMuMjIzODYgNyAzIDYuNzc2MTQgMyA2LjVDMyA2LjIyMzg2IDMuMjIzODYgNiAzLjUgNkg2Wk01LjUgOEM1Ljc3NjE0IDggNiA4LjIyMzg2IDYgOC41VjE4LjVDNiAxOS4zMjg0IDYuNjcxNTcgMjAgNy41IDIwSDE1LjVDMTYuMzI4NCAyMCAxNyAxOS4zMjg0IDE3IDE4LjVWOC41QzE3IDguMjIzODYgMTcuMjIzOSA4IDE3LjUgOEMxNy43NzYxIDggMTggOC4yMjM4NiAxOCA4LjVWMTguNUMxOCAxOS44ODA3IDE2Ljg4MDcgMjEgMTUuNSAyMUg3LjVDNi4xMTkyOSAyMSA1IDE5Ljg4MDcgNSAxOC41VjguNUM1IDguMjIzODYgNS4yMjM4NiA4IDUuNSA4Wk0xMCA4LjVDMTAgOC4yMjM4NiA5Ljc3NjE0IDggOS41IDhDOS4yMjM4NiA4IDkgOC4yMjM4NiA5IDguNVYxNy41QzkgMTcuNzc2MSA5LjIyMzg2IDE4IDkuNSAxOEM5Ljc3NjE0IDE4IDEwIDE3Ljc3NjEgMTAgMTcuNVY4LjVaTTEzLjUgOEMxMy43NzYxIDggMTQgOC4yMjM4NiAxNCA4LjVWMTcuNUMxNCAxNy43NzYxIDEzLjc3NjEgMTggMTMuNSAxOEMxMy4yMjM5IDE4IDEzIDE3Ljc3NjEgMTMgMTcuNVY4LjVDMTMgOC4yMjM4NiAxMy4yMjM5IDggMTMuNSA4WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";